import { useState } from "react";
import Slider from "react-slick";
import ImageProductZoom from "./image-product-zoom";

export const ProductImageGallery = ({
  images,
  isSample,
}: {
  images: any[];
  isSample: boolean;
}) => {
  if (images.length === 1) {
    images.push(images[0]);
  }
  const [nav1, setNav1] = useState<any>(null);
  const [nav2, setNav2] = useState<any>(null);
  const [selectedImage, setSelectedImage] = useState<any>(images[0]);

  console.log("selectedImage", selectedImage);

  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: nav2,
  };

  const settingsThumbs = {
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: nav1,
    focusOnSelect: true,
  };

  return (
    <div className="single-pro-img">
      {selectedImage != null ? (
        <div
          style={{
            marginBottom: "7px",
          }}
          onMouseLeave={() => setSelectedImage(null)}
        >
          <ImageProductZoom
            image={`https://d1gdand68muq63.cloudfront.net/${
              isSample ? "sample-products" : "products"
            }/original/${selectedImage.key}`}
            alt={`Product Image`}
          />
        </div>
      ) : (
        <Slider {...settingsMain} ref={(slider1) => setNav1(slider1)}>
          {images.map((img, idx) => (
            <div
              className="single-slide zoom-image-hover"
              key={idx}
              onMouseEnter={() => setSelectedImage(images[idx])}
              onMouseLeave={() => setSelectedImage(null)}
            >
              <img
                className="img-responsive"
                src={`https://d1gdand68muq63.cloudfront.net/${
                  isSample ? "sample-products" : "products"
                }/original/${img.key}`}
                alt={`Product Image ${idx + 1}`}
              />
            </div>
          ))}
        </Slider>
      )}

      <Slider
        className="single-nav-thumb slick-initialized slick-slider"
        {...settingsThumbs}
        ref={(slider2) => setNav2(slider2)}
      >
        {images.map((img, idx) => (
          <div className="single-slide" key={idx}>
            <img
              className="img-responsive"
              src={`https://d1gdand68muq63.cloudfront.net/${
                isSample ? "sample-products" : "products"
              }/96/${img.key}`}
              alt={`Thumbnail ${idx + 1}`}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};
